module.exports = __webpack_public_path__ + "static/media/three_monkey_P4.cc78574b.png";